export interface TranslationSuggestion {
  id: string;
  text: string;
  status: 'Beküldve' | 'Elfogadva' | 'Elutasítva';
  author: string;
}

export interface TranslationString {
  id: string;
  original: string;
  translation: string;
  germanTranslation?: string;
  suggestions?: TranslationSuggestion[];
}

export interface TranslationFile {
  id: string;
  name: string;
  strings: TranslationString[];
}

export interface GameVersion {
  id: string;
  versionNumber: string;
  files: TranslationFile[];
}

export interface Game {
  id: string;
  name: string;
  description: string;
  imageUrl: string;
  versions: GameVersion[];
}

export const games: Game[] = [
  {
    id: 'stardew-valley',
    name: 'Stardew Valley',
    description: 'Egy bájos farm szimulátor, ahol új életet kezdesz a vidéken.',
    imageUrl: '/placeholder.svg',
    versions: [
      {
        id: '1.5.6',
        versionNumber: '1.5.6',
        files: [
          {
            id: 'ui',
            name: 'ui.json',
            strings: [
              { 
                id: '1', 
                original: 'Play', 
                translation: 'Játszás',
                germanTranslation: 'Spielen',
                suggestions: [
                  { id: 's1', text: 'Játszás', status: 'Elfogadva', author: 'Fordító_1' },
                  { id: 's2', text: 'Játék', status: 'Elutasítva', author: 'Fordító_2' },
                  { id: 's3', text: 'Indítás', status: 'Beküldve', author: 'Fordító_3' },
                ]
              },
              { id: '2', original: 'Options', translation: 'Beállítások' },
              { id: '3', original: 'Exit', translation: 'Kilépés' },
            ],
          },
          {
            id: 'dialogue',
            name: 'dialogue.json',
            strings: [
              { id: '1', original: 'Hello, farmer!', translation: 'Szia, gazda!' },
              { 
                id: '2', 
                original: 'What a beautiful day!', 
                translation: '',
                suggestions: [
                  { id: 's4', text: 'Milyen szép nap!', status: 'Beküldve', author: 'Fordító_1' },
                  { id: 's5', text: 'Csodás ez a nap!', status: 'Beküldve', author: 'Fordító_2' },
                ]
              },
            ],
          },
        ],
      },
      {
        id: '1.6.0',
        versionNumber: '1.6.0',
        files: [
            {
                id: 'ui',
                name: 'ui.json',
                strings: [
                  { id: '1', original: 'Play Game', translation: '' },
                  { id: '2', original: 'Settings', translation: 'Beállítások' },
                  { id: '3', original: 'Quit', translation: 'Kilépés' },
                ],
              },
        ]
      }
    ],
  },
  {
    id: 'cyberpunk-2077',
    name: 'Cyberpunk 2077',
    description: 'Egy nyílt világú akció-szerepjáték, amely Night Cityben játszódik.',
    imageUrl: '/placeholder.svg',
    versions: [
      {
        id: '2.0',
        versionNumber: '2.0',
        files: [
          {
            id: 'main_quests',
            name: 'main_quests.xml',
            strings: [
              { id: '1', original: 'Wake up, Samurai. We have a city to burn.', translation: '' },
            ],
          },
        ],
      },
    ],
  },
];